import { Button, Divider, Typography } from "@mui/material";
import { EPath } from "constants/path";
import React from "react";
import { useNavigate } from "react-router";

import LegalDialog from "./LegalDialog";

interface DisclaimerStepOneModalProps {
  open: boolean;
  onContinue: () => void;
}

const DisclaimerStepOneModal: React.FC<DisclaimerStepOneModalProps> = ({
  open,
  onContinue,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(EPath.LOGIN);
  };

  return (
    <LegalDialog
      open={open}
      onClose={handleClose}
      title="Important Disclaimer: Not a Medical Device"
      maxWidth="sm"
      actions={
        <Button
          onClick={onContinue}
          variant="contained"
          className="px-8 py-2"
          sx={{ borderRadius: "9999px", minWidth: 200 }}
          fullWidth
        >
          Continue
        </Button>
      }
    >
      <div className="space-y-3">
        <Typography variant="body2">
          The <b>Cellera</b> app and its affiliated services are for general
          wellness and informational purposes only. The app is not a medical
          device and is not intended to be a substitute for professional medical
          advice, diagnosis, treatment, or cure of any disease, condition, or
          medical problem.
        </Typography>
        <Typography variant="body2">
          Any insights, recommendations, or data provided by the app, including
          those generated by the AI assistant, are not a replacement for advice
          from a qualified healthcare professional.
        </Typography>
        <Divider sx={{ my: 4 }} />
        <Typography variant="body2" sx={{ mt: 1 }}>
          You should not delay seeking, disregard, or modify medical advice from
          your doctor or other healthcare professional based on information
          provided by this app.
        </Typography>
        <Typography variant="body2">
          If you think you are experiencing a medical emergency, you should call
          your doctor or 911 immediately.
        </Typography>
        <Typography variant="body2">
          By continuing to use this app, you acknowledge and agree to this
          disclaimer.
        </Typography>
      </div>
    </LegalDialog>
  );
};

export default DisclaimerStepOneModal;
